import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  GetAgentsQuery,
  GetAgentQuery,
  GetAgentQueryVariables,
} from '#graphql/generated';

export const GET_AGENTS: TypedDocumentNode<GetAgentsQuery> = gql`
  query GetAgents {
    agents {
      agents {
        id
        userId
        name
        cron
        processorId
        parameters
        enabled
        lastRunAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_AGENT: TypedDocumentNode<
  GetAgentQuery,
  GetAgentQueryVariables
> = gql`
  query GetAgent($id: String!) {
    agent(id: $id) {
      id
      userId
      name
      cron
      processorId
      parameters
      enabled
      lastRunAt
      createdAt
      updatedAt
    }
  }
`;
